<div [formGroup]="form">
    <!-- Territorio con buscador -->
    <mat-form-field *ngIf="territory" appearance="fill" class="w-full">
        <mat-label class="block text-gray-700 border-gray-300 pb-[2px] mb-[4px]">Territorio</mat-label>
        <mat-select formControlName="routeId" multiple placeholder="Seleccione Territorio">

            <mat-select-trigger>
                {{ getDisplayValue(territoryList, form.get('routeId')?.value,"externalKeys[code]", "name")}}
            </mat-select-trigger>

            <!-- Buscador dentro del select -->
            <mat-option>
                <ngx-mat-select-search [(ngModel)]="searchTerritory" [ngModelOptions]="{ standalone: true }"
                    placeholderLabel="Buscar territorio..." noEntriesFoundLabel="No se encontraron resultados"
                    (ngModelChange)="filterTerritory($event)">
                </ngx-mat-select-search>
            </mat-option>

            <!-- Opciones filtradas -->
            <mat-option *ngFor="let type of filteredTerritoryList" [value]="type.id">
                <span class="font-semibold">{{ type?.externalKeys?.code }} -</span> {{ type.name }}
            </mat-option>
        </mat-select>
    </mat-form-field>

    <!-- Territorio con MongoID -->
    <mat-form-field *ngIf="territoryWithMongoId" appearance="fill" class="w-full">
        <mat-label class="block text-gray-700 border-gray-300 pb-[2px] mb-[4px]">Territorio</mat-label>
        <mat-select formControlName="routeId" multiple placeholder="Seleccione Territorio">

            <mat-select-trigger>
                {{ getDisplayValueForMongoId(territoryList, form.get('routeId')?.value,"externalKeys[code]", "name")}}
            </mat-select-trigger>

            <!-- Buscador dentro del select -->
            <mat-option>
                <ngx-mat-select-search [(ngModel)]="searchTerritory" [ngModelOptions]="{ standalone: true }"
                    placeholderLabel="Buscar territorio..." noEntriesFoundLabel="No se encontraron resultados"
                    (ngModelChange)="filterTerritory($event)">
                </ngx-mat-select-search>
            </mat-option>

            <!-- Opciones filtradas -->
            <mat-option *ngFor="let type of filteredTerritoryList" [value]="type._id">
                <span class="font-semibold">{{ type?.externalKeys?.code }} -</span> {{ type.name }}
            </mat-option>
        </mat-select>
    </mat-form-field>

    <!-- Área de Ruta sin buscador -->
    <mat-form-field appearance="fill" *ngIf="areaRoute" class="w-full">
        <mat-label>Área de Ruta</mat-label>
        <mat-select formControlName="routeAreaId" multiple placeholder="Seleccione Área de Ruta">
            <mat-select-trigger>
                {{ getDisplayValue(areaRouteList, form.get('routeAreaId')?.value, "name")}}
            </mat-select-trigger>

            <mat-option *ngFor="let type of areaRouteList" [value]="type.id">
                {{ type.name }}
            </mat-option>
        </mat-select>
    </mat-form-field>

    <!-- Grupo de Ruta sin buscador -->
    <mat-form-field appearance="fill" *ngIf="routeGroup" class="w-full">
        <mat-label>Grupo de Ruta</mat-label>
        <mat-select formControlName="routeGroupId" multiple placeholder="Seleccione Grupo de Ruta">

            <mat-select-trigger>
                {{ getDisplayValue(routeGroupList, form.get('routeGroupId')?.value, "name")}}
            </mat-select-trigger>

            <mat-option *ngFor="let type of routeGroupList" [value]="type.id">
                {{ type.name }}
            </mat-option>
        </mat-select>
    </mat-form-field>

    <!-- Tipo de Ruta sin buscador -->
    <mat-form-field appearance="fill" *ngIf="type" class="w-full">
        <mat-label>Tipo de Ruta</mat-label>
        <mat-select formControlName="routeTypeId" placeholder="Seleccione Tipo de Ruta">
            <mat-option [value]="null">{{ 'Ninguno' | transloco }}</mat-option>
            <mat-option *ngFor="let type of typeList" [value]="type.value">
                {{ type.key | transloco }}
            </mat-option>
        </mat-select>
    </mat-form-field>

    <!-- Ruta(s) con buscador -->
    <mat-form-field appearance="fill" *ngIf="route" class="w-full">
        <mat-label>Ruta(s)</mat-label>
        <mat-select formControlName="subRouteId" multiple placeholder="Seleccione Ruta(s)"
            panelClass="select-panel-with-search">

            <mat-select-trigger>
                {{ getDisplayValue(routeList, form.get('subRouteId')?.value, "name")}}
            </mat-select-trigger>

            <mat-option disabled>
                <ngx-mat-select-search [(ngModel)]="routeSearch" [ngModelOptions]="{ standalone: true }"
                    placeholderLabel="Buscar Ruta..." noEntriesFoundLabel="No se encontraron resultados"
                    (ngModelChange)="filteredRoutesList($event)">
                </ngx-mat-select-search>
            </mat-option>
            <mat-option *ngFor="let type of filteredRouteList" [value]="type.id">
                <div *ngIf="getCode(type) as code">
                    <b class="f-10">{{ code }}</b>
                </div>
                {{ type.name }}
            </mat-option>
        </mat-select>
    </mat-form-field>

    <!-- Ruta(s) con MongoID -->
    <mat-form-field appearance="fill" *ngIf="routeWithMongoId" class="w-full">
        <mat-label>Ruta(s)</mat-label>
        <mat-select formControlName="subRouteId" multiple placeholder="Seleccione Ruta(s)"
            panelClass="select-panel-with-search">

            <mat-select-trigger>
                {{ getDisplayValueForMongoId(routeList, form.get('subRouteId')?.value, "name")}}
            </mat-select-trigger>

            <mat-option disabled>
                <ngx-mat-select-search [(ngModel)]="routeSearch" [ngModelOptions]="{ standalone: true }"
                    placeholderLabel="Buscar Ruta..." noEntriesFoundLabel="No se encontraron resultados"
                    (ngModelChange)="filteredRoutesList($event)">
                </ngx-mat-select-search>
            </mat-option>
            <mat-option *ngFor="let type of filteredRouteList" [value]="type._id">
                {{ type.name }}
            </mat-option>
        </mat-select>
    </mat-form-field>

    <!-- Modelo sin buscador -->
    <mat-form-field appearance="fill" *ngIf="modelList?.length" class="w-full">
        <mat-label>Modelo de Ruta</mat-label>
        <mat-select formControlName="modelEnum" multiple placeholder="Seleccione modelo de Ruta">

            <mat-select-trigger>
             {{ getModelDisplay(form.get('modelEnum')?.value, modelList) }}
            </mat-select-trigger>

            <mat-option *ngFor="let model of modelList" [value]="model.value">
                {{ model.key | transloco }}
            </mat-option>
        </mat-select>
    </mat-form-field>

    <mat-form-field appearance="fill" *ngIf="function" class="w-full">
        <mat-label>Función</mat-label>
        <mat-select formControlName="functionCodes" multiple placeholder="Seleccione una o más funciones">

            <mat-select-trigger>
             {{ getDisplayValue(functionList, form.get('functionCodes')?.value, "name") }}
            </mat-select-trigger>

            <mat-option *ngFor="let item of functionList" [value]="item.code">
                {{ item.name | transloco }}
            </mat-option>
        </mat-select>
    </mat-form-field>

    <mat-form-field *ngIf="statusTrip" appearance="fill" class="w-full">
        <mat-label>Estado de Viaje</mat-label>
        <mat-select formControlName="statusTripId" placeholder="Seleccione estado de viaje">

            <mat-select-trigger>
             {{ getDisplayValue(statusList, form.get('statusTripId')?.value, "value") }}
            </mat-select-trigger>

            <mat-option *ngFor="let item of statusList" [value]="item.code">
                {{ item.value }}
            </mat-option>
        </mat-select>
    </mat-form-field>

    <!-- Motivos de visita con buscador -->
    <mat-form-field *ngIf="reasonVisit && !flagReasonVisitName" appearance="fill" class="w-full">
        <mat-label class="block text-gray-700 border-gray-300 pb-[2px] mb-[4px]">Motivo de Visita</mat-label>
        <mat-select formControlName="reasonVisitId" multiple placeholder="Seleccione motivo de visita">

            <mat-select-trigger>
                {{ getModelDisplay(form.get('reasonVisitId')?.value, reasonVisitList)}}
            </mat-select-trigger>

            <!-- Buscador dentro del select -->
            <mat-option>
                <ngx-mat-select-search [(ngModel)]="searchReasonVisit" [ngModelOptions]="{ standalone: true }"
                    placeholderLabel="Buscar motivo de visita..." noEntriesFoundLabel="No se encontraron resultados"
                    (ngModelChange)="filterReasonVisit($event)">
                </ngx-mat-select-search>
            </mat-option>

            <!-- Opciones filtradas -->
            <mat-option *ngFor="let type of filteredReasonVisitList" [value]="type.id">
                {{ type.name }}
            </mat-option>
        </mat-select>
    </mat-form-field>

    <mat-form-field *ngIf="reasonVisit && flagReasonVisitName" appearance="fill" class="w-full">
        <mat-label class="block text-gray-700 border-gray-300 pb-[2px] mb-[4px]">Motivo de Visita</mat-label>
        <mat-select formControlName="reasonVisit" placeholder="Seleccione motivo de visita">

            <!-- Buscador dentro del select -->
            <mat-option>
                <ngx-mat-select-search [(ngModel)]="searchReasonVisit" [ngModelOptions]="{ standalone: true }"
                    placeholderLabel="Buscar motivo de visita..." noEntriesFoundLabel="No se encontraron resultados"
                    (ngModelChange)="filterReasonVisit($event)">
                </ngx-mat-select-search>
            </mat-option>

            <!-- Opciones filtradas -->
            <mat-option *ngFor="let type of filteredReasonVisitList" [value]="type.name">
                {{ type.name }}
            </mat-option>
        </mat-select>
    </mat-form-field>

    <mat-form-field *ngIf="frecuency" appearance="fill" class="w-full">
        <mat-label>Frecuencia</mat-label>
        <mat-select formControlName="frecuencyRoute" name="frecuencyRoute">
            <mat-option *ngFor="let frecuency of frecuencyList" [value]="frecuency">
            {{ getFrecuencyDays(frecuency.days) }}
            </mat-option>
        </mat-select>
    </mat-form-field>


    <mat-form-field *ngIf="frecuencyDay" appearance="fill" class="w-full">
        <mat-label>Frecuencia</mat-label>
        <mat-select formControlName="frecuencyRoute" name="frecuencyRoute">
            <mat-option *ngFor="let frecuency of daysList" [value]="frecuency.code">
            {{ frecuency.day }}
            </mat-option>
        </mat-select>
    </mat-form-field>
</div>